/*
  This file is part of Universal Sequencer.
  Universal Sequencer is free software: you can redistribute it and/or modif
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  Universal Sequences is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { useCallback, useEffect, useState, Component } from 'react';
import Key from './Key.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const rows =
      [['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
       ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
       ['Z', 'X', 'C', 'V', 'B', 'N', 'M']];

const Keyboard = (props) => {
    let [keys, setKeys] = useState({});

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        window.addEventListener("keyup", onKeyUp);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
            window.removeEventListener("keyup", onKeyUp);
        };
    }, [setKeys, keys]);

    const onKeyUp = useCallback((e) => {
        if (!e.key || !e.key.toUpperCase) {
            return;
        }
        let _keys = {... keys};
        delete _keys[e.key.toUpperCase()];
        setKeys(_keys);
    }, [keys, setKeys]);

    const onKeyDown = useCallback((e) => {
        if (!e.key || !e.key.toUpperCase) {
            return;
        }
        let _keys = {... keys};
        _keys[e.key.toUpperCase()] = true;
        setKeys(_keys);
    }, [setKeys, keys]);

    const getKey = (value) => {
        return value.toLowerCase();
    };

    let className = props.mini ? 'keyboard mini' : 'keyboard';
    let style = {
    };
    if (props.track) {
        style.borderColor = colors.getColorForTrack(props.track);
    }
    return (
        <div style={style} className={className}>
          <div className='keyboard-row'>
            {rows[0].map((x) =><Key
                          key={x}
                                 pressed={keys[x]}
                          helper={props.helper}
                          mini={props.mini}
                          selectedSlice={props.selectedSlice}
                          keyboardKey={getKey(x)}
                                 selectedTrack={props.selectedTrack}
                          sequencerEngine={props.sequencerEngine}
                          trackNumber={props.trackNumber}
                          keyboardEngine={props.keyboardEngine}
                          value={x}/>)}
          </div>
          <div className='keyboard-row keyboard-row-2'>
            {rows[1].map(
                (key) =>
                    <Key
                      helper={props.helper}
                      key={key}
                      mini={props.mini}
                      selectedSlice={props.selectedSlice}
                                 pressed={keys[key]}
                      selectedTrack={props.selectedTrack}
                      keyboardKey={getKey(key)}
                      sequencerEngine={props.sequencerEngine}
                      trackNumber={props.trackNumber} keyboardEngine={props.keyboardEngine} value={key}/>)}
          </div>
          <div className='keyboard-row keyboard-row-3'>
            {rows[2].map(
                (key) =>
                    <Key
                      key={key}
                      helper={props.helper}
                      mini={props.mini}
                      selectedSlice={props.selectedSlice}
                                 pressed={keys[key]}
                      selectedTrack={props.selectedTrack}
                      keyboardKey={getKey(key)}
                      sequencerEngine={props.sequencerEngine}
                      trackNumber={props.trackNumber} keyboardEngine={props.keyboardEngine} value={key}/>)}</div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        selectedTrack: state.mix.selectedTrack
    };
};

export default Keyboard;
